import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@/lib/auth'
import { useIsAdmin } from '@/lib/admin'

/**
 * Route gate for /admin/*. Layers on top of the existing auth gate:
 *   - If still bootstrapping auth or the admin lookup hasn't completed,
 *     render nothing (no flicker).
 *   - If signed out, redirect to /sign-in.
 *   - If signed in but not super-admin, send to the homepage (no 403 page
 *     — pretend the route doesn't exist for non-admins).
 *   - Otherwise render the protected children.
 */
export function AdminGuard({ children }: { children: ReactNode }) {
  const { session, loading: authLoading } = useAuth()
  const { isAdmin, loading: adminLoading } = useIsAdmin()

  if (authLoading || adminLoading) return null
  if (!session) return <Navigate to="/sign-in" replace />
  if (!isAdmin) return <Navigate to="/" replace />
  return <>{children}</>
}
